import * as axios from '../axios-extended'
import * as t from 'io-ts'
import { UAAAccount } from '@library/react-toolkit'

export const updateUAAAccount = (
  account: UAAAccount,
  cancelToken?: axios.CancelToken
) =>
  axios.post('/uaa/api/account', account, {
    cancelToken,
    encoder: UAAAccount,
    decoder: t.unknown,
  })
